import { render, staticRenderFns } from "./AdminLogin.vue?vue&type=template&id=24d0c2d3&scoped=true&"
import script from "./AdminLogin.vue?vue&type=script&lang=js&"
export * from "./AdminLogin.vue?vue&type=script&lang=js&"
import style0 from "./AdminLogin.vue?vue&type=style&index=0&id=24d0c2d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d0c2d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCardText,VForm,VIcon,VTextField})
